import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { eur, num, showMoney } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { HandCoins } from "lucide-react";

export const AdviceStats = () => {
  const { data } = useQuery({ queryKey: ["advice-stats"], queryFn: async () => (await api.get("/customers/advice/stats")).data });
  if (!data) return null;
  const t = data.totals;
  return (
    <Card className="mb-6 overflow-hidden" data-testid="advice-stats">
      <div className="border-b border-border/60 px-6 py-4">
        <h3 className="flex items-center gap-2 font-display text-lg font-semibold"><HandCoins className="h-4 w-4 text-primary" />Vendite dai consigli</h3>
        <p className="text-xs text-muted-foreground">
          Capi proposti dalla scheda cliente e acquistati dalla cliente (stesso capo e taglia) entro {data.days} giorni.
          {t.proposals > 0 && ` Totale: ${num(t.proposals)} proposte, ${num(t.sold_units)} capi venduti${showMoney() ? `, ${eur(t.revenue)}` : ""}.`}
        </p>
      </div>
      {data.by_user.length === 0 ? (
        <p className="px-6 py-6 text-sm text-muted-foreground" data-testid="advice-stats-empty">Nessuna proposta ancora. Apri una cliente con le misure, spunta i capi consigliati e premi "Prepara messaggio".</p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead>Dipendente</TableHead><TableHead className="text-right">Proposte</TableHead><TableHead className="text-right">Clienti</TableHead>
              <TableHead className="text-right">Andate a buon fine</TableHead><TableHead className="text-right">Capi venduti</TableHead>{showMoney() && <TableHead className="text-right">Venduto</TableHead>}
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.by_user.map((r) => (
              <TableRow key={r.name} data-testid={`advice-user-${r.name}`}>
                <TableCell className="font-medium">{r.name}</TableCell>
                <TableCell className="text-right">{num(r.proposals)}</TableCell>
                <TableCell className="text-right">{num(r.customers)}</TableCell>
                <TableCell className="text-right">{num(r.converted)} <span className="text-xs text-muted-foreground">({num(r.conversion)}%)</span></TableCell>
                <TableCell className="text-right font-semibold">{num(r.sold_units)}</TableCell>
                {showMoney() && <TableCell className="text-right">{eur(r.revenue)}</TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Card>
  );
};
